import type { Dispatch } from 'react';
import type { InvalidItemsError } from '../../BulkAdd/types';
import { type Action, Actions } from './types';

export const dispatchChangeHandler = (dispatch: Dispatch<Action>, text: string) => {
  dispatch({
    type: Actions.Change_Handler,
    payload: {
      text,
    },
  });
};

export const dispatchReset = (dispatch: Dispatch<Action>, formattedText: string) => {
  dispatch({
    type: Actions.Reset,
    payload: {
      formattedText,
    },
  });
};

export const dispatchValidate = (dispatch: Dispatch<Action>, errors: InvalidItemsError[], validItems: string[]) => {
  dispatch({
    type: Actions.Validate,
    payload: {
      errors,
      validItems,
      text: validItems.join('\n'),
    },
  });
};

export const dispatchSetResetEnabled = (dispatch: Dispatch<Action>) => {
  dispatch({
    type: Actions.SetResetEnabled,
  });
};

export const dispatchSetValidating = (dispatch: Dispatch<Action>, isValidating: boolean) => {
  dispatch({
    type: Actions.SetValidating,
    payload: isValidating,
  });
};
